import React from 'react';
import { tokens as t, fonts as font } from '../../tokens';

export function Tabs({ tabs, activeKey, onChange, size = "md", variant = "underline" }) {
  const sizes = { sm: { fontSize: 12, padding: "8px 12px" }, md: { fontSize: 13, padding: "11px 16px" } };
  const s = sizes[size] || sizes.md;

  return (
    <div style={{ display: "flex", gap: variant === "pill" ? 4 : 0, fontFamily: font.body }}>
      {tabs.map(tab => {
        const key = typeof tab === "string" ? tab : tab.key;
        const label = typeof tab === "string" ? tab : tab.label;
        const count = typeof tab === "object" ? tab.count : undefined;
        const isActive = key === activeKey;

        const underlineStyle = {
          background: "none", border: "none",
          borderBottom: `2.5px solid ${isActive ? t.emerald : "transparent"}`,
          color: isActive ? t.textPrimary : t.textSecondary,
          fontWeight: isActive ? 700 : 400,
        };

        const pillStyle = {
          background: isActive ? t.emerald : "transparent",
          color: isActive ? "#fff" : t.textSecondary,
          fontWeight: isActive ? 700 : 500,
          border: "none", borderRadius: 99,
        };

        return (
          <button
            key={key}
            className={!isActive ? "rf-tab" : ""}
            onClick={() => onChange && onChange(key)}
            style={{
              cursor: "pointer", fontFamily: font.body, outline: "none",
              display: "inline-flex", alignItems: "center", gap: 6,
              transition: "all 0.15s",
              ...s,
              ...(variant === "pill" ? pillStyle : underlineStyle),
            }}
          >
            {label}
            {count !== undefined && (
              <span style={{
                fontSize: 10, fontWeight: 700, fontFamily: font.mono,
                background: isActive && variant === "pill" ? "rgba(255,255,255,0.25)" : isActive ? `${t.emerald}18` : "#f3f4f6",
                color: isActive && variant === "pill" ? "#fff" : isActive ? t.emeraldDeep : t.textMuted,
                padding: "1px 6px", borderRadius: 99,
              }}>{count}</span>
            )}
          </button>
        );
      })}
    </div>
  );
}

export function TabPanel({ children, tabKey, activeKey }) {
  if (activeKey !== tabKey) return null;
  return <div>{children}</div>;
}
